<template>
    <div>
        <div class="card">
            <div class="card-header d-block border-bottom">
                <div class="text-center">
                    <h4 class="font-weight-bolder text-uppercase text-primary">SK TIM INVENTARISASI PERALATAN DAN MESIN
                        <br /> PADA {{ headerSkTim }}
                    </h4>
                </div>
                <div style="position: absolute; top:20px;right: 20px;">
                    <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="secondary" class="btn-icon"
                        @click="changeStateEvent('detail')">
                        <feather-icon icon="CornerUpLeftIcon" />
                    </b-button>
                </div>
            </div>
            <div class="card-body pt-1">
                <div class="row py-1 px-0 ml-0">
                    <div class="col-12">
                        <div class="d-flex flex-row justify-content-between overflow-auto">
                            <div class="mr-2" style="width: max-content;">
                                <div style="margin-bottom: 5px;">
                                    <span class="font-weight-bolder text-uppercase">Nama PD/UKPD/UPB</span>
                                </div>
                                <div>
                                    <span class="font-size-lg">{{ formDatas.nalok || '-' }}</span>
                                </div>
                            </div>
                            <div class="text-center border rounded border-light bg-light"
                                style="width: 200px; height: 60px; position: relative;">
                                <div
                                    style="position: absolute; top: 20px; left: 50%; transform: translate(-50%, -50%); width: max-content;">
                                    <span class="font-weight-bold text-uppercase">Status</span>
                                </div>
                                <div class="overflow-auto" style="margin: 30px 5px 10px 5px;">
                                    <b-badge variant="light-primary">
                                        {{ formDatas.nama_status || formDatas.status || '-' }}
                                    </b-badge>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <template v-for="(item, i) in formDatas.data_struktural" :keys="i">
                    <div class="border px-1 border-1 py-1 px-0 mx-0 mb-1 rounded bg-light-secondary">
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <h5 class="font-weight-bold text-uppercase">
                                            <span v-if="item.ref_jabatan_sk_tim_kode == 'ketua'">Ketua ({{
                                                lebelField('ketua') }})</span>
                                            <span v-else-if="item.ref_jabatan_sk_tim_kode == 'wakil'">Wakil Ketua
                                                (Pejabat
                                                Eselon
                                                II/III)</span>
                                            <span v-else-if="item.ref_jabatan_sk_tim_kode == 'sekretaris'">Sekretaris
                                                ({{ lebelField('sekretaris') }})</span>
                                            <span v-else-if="item.ref_jabatan_sk_tim_kode == 'sekretariat'">Sekretariat
                                                ({{ lebelField('sekretariat') }})</span>
                                            <span v-else>{{ item.ref_jabatan_sk_tim_kode }}</span>
                                            <span v-if="item.is_plt == 'iya'" class="text-warning ml-50">(PLT)</span>
                                        </h5>
                                    </div>
                                    <div>
                                        <b-button v-if="!item.on_edit" v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                            variant="danger" size="sm" style="margin-right: 5px;"
                                            @click="openDeleteModal(i, 'struktural')">
                                            <feather-icon icon="Trash2Icon" style="margin-right: 5px;" />
                                            <span class="align-middle">Hapus</span>
                                        </b-button>
                                        <b-button v-if="!item.on_edit" v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                            variant="warning" size="sm" @click="item.on_edit = true">
                                            <feather-icon icon="EditIcon" style="margin-right: 5px;" />
                                            <span class="align-middle">Edit</span>
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <FormLookupPegawai :parentData="formDatas" :modelValue="item" :updateItem="updateDataStruktural"
                            :index="i" />
                    </div>
                </template>
                <hr class="my-2" />
                <div class="row mb-1">
                    <div class="col-12">
                        <div>
                            <h5 class="font-weight-bold text-uppercase text-muted">Daftar Anggota ({{ lebelField('anggota')
                            }})
                            </h5>
                        </div>
                        <b-alert show variant="warning">
                            <div class="alert-body">
                                <div class="d-flex flex-row align-items-center" style="gap: 5px;">
                                    <div class="icon-wrapper">
                                        <feather-icon icon="InfoIcon" class="mr-50 mt-25" />
                                    </div>
                                    <div>
                                        <span>Maksimal Anggota 40 Orang</span>
                                    </div>
                                </div>
                            </div>
                        </b-alert>
                    </div>
                </div>
                <template v-for="(item, i) in formDatas.data_anggota" :keys="i">
                    <div class="border px-1 border-1 py-1 px-0 mx-0 mb-1 rounded bg-light-secondary">
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <h5 class="font-weight-bolder text-uppercase">Anggota {{ i + 1 }}</h5>
                                    </div>
                                    <div>
                                        <b-button v-if="!item.on_edit" v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                            variant="danger" size="sm" style="margin-right: 5px;"
                                            @click="openDeleteModal(i, 'anggota')">
                                            <feather-icon icon="Trash2Icon" style="margin-right: 5px;" />
                                            <span class="align-middle">Hapus</span>
                                        </b-button>
                                        <b-button v-if="!item.on_edit" v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                            variant="warning" size="sm" @click="item.on_edit = true">
                                            <feather-icon icon="EditIcon" style="margin-right: 5px;" />
                                            <span class="align-middle">Edit</span>
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <FormLookupPegawai :isAnggota="true" :modelValue="item" :updateItem="updateDataAnggota"
                            :index="i" />
                    </div>
                </template>
                <b-row class="mb-1" v-if="formDatas.data_anggota && formDatas.data_anggota.length < 40">
                    <b-col cols="12">
                        <div class="d-flex justify-content-start">
                            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-primary" size="sm"
                                @click="addNewAnggota">
                                <feather-icon icon="UserPlusIcon" class="mr-50" />
                                <span class="align-middle">Tambah Anggota</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="card-footer">
                <div class="d-flex flex-row flex-wrap justify-content-between">
                    <div class="mb-1 mb-md-0 mb-lg-0">
                        <b-button v-if="!loadingBtnPengajuan" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="danger"
                            @click="openPengajuanValidasiDialog">
                            <feather-icon icon="SendIcon" class="mr-50" />
                            <span class="align-middle">Pengajuan Validasi P3B</span>
                        </b-button>
                        <b-button v-else variant="danger" disabled class="mr-1">
                            <b-spinner small />
                            Loading...
                        </b-button>
                    </div>
                    <div class="d-flex flex-row flex-wrap">
                        <div class="mb-1 mb-md-0 mb-lg-0">
                            <b-button v-if="!loadingBtnSaveAsDraft" v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                variant="primary" @click="saveAsDraft">
                                <feather-icon icon="EditIcon" class="mr-50" />
                                <span class="align-middle">Simpan Draft</span>
                            </b-button>
                            <b-button v-else variant="primary" disabled class="mr-1">
                                <b-spinner small />
                                Loading...
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal centered id="modal-footer-sm" ref="deleteModalRef" title="Hapus Personil" button-size="sm" ok-title="Hapus"
            cancel-title="Batal" cancel-variant="outline-secondary" @ok="confirmDeletePersonil">
            <b-card-text>
                Data personil SK Tim akan dihapus. Lanjutkan ?
            </b-card-text>
        </b-modal>
        <b-modal centered id="modal-pengajuan-validasi" ref="pengajuanValidasiModalRef" title="Pengajuan Validasi"
            button-size="sm" ok-title="Kirim" cancel-title="Batal" cancel-variant="outline-secondary"
            @ok="confirmKirimPengajuanValidasi">
            <b-card-text>
                Data SK Tim akan diajukan validasi kepada P3B. Lanjutkan ?
            </b-card-text>
        </b-modal>
    </div>
</template>
  
<script>
import { BButton, BModal, VBModal } from 'bootstrap-vue'

import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import skTim from "@/composables/b/skTim";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate' //del later
import { required } from '@validations'; //del later
import { showNotifikasi } from '@/libs/helper';
import FormLookupPegawai from '../components/FormLookupPegawai.vue';

export default {
    props: {
        fd: { type: Object, required: true },
        parentFilter: { type: Object, required: true }
    },
    setup(props, context) {
        //global variable
        const g = context.root;
        const $route = g.$route;
        const formDatas = ref({});
        const getData = () => {
            let params = props.parentFilter;
            skTim.getDetail(g, params).then(res => {
                formDatas.value = { ...formDatas.value, ...res.data }
                generateFormDatas();
            }).catch(err => {
                console.log(err)
            });
        };
        getData();

        const generateFormDatas = () => {
            let tempDataStruktural = [];
            let tempDataAnggota = [
                { kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'anggota', nrk: null, nama: null, nip: null, is_plt: 'tidak' },
            ];
            /* Nanti props.fd.tipe_kolok diganti menjadi data.tipe_kolok */
            if (formDatas.value.tipe_kolok == 'skpd') {
                tempDataStruktural = [
                    { kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'ketua', nrk: null, nama: null, nip: null, is_plt: 'tidak' },
                    { kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'wakil', nrk: null, nama: null, nip: null, is_plt: 'tidak' },
                    { kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'sekretaris', nrk: null, nama: null, nip: null, is_plt: 'tidak' },
                    { kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'sekretariat', nrk: null, nama: null, nip: null, is_plt: 'tidak' },
                ];
                const itemKetua = (formDatas.value.data_struktural) ? (formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'ketua')) : null;
                const itemWakilKetua = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'wakil') : null;
                const itemSekretaris = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'sekretaris') : null;
                const itemSekretariat = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'sekretariat') : null;
                if (itemKetua) tempDataStruktural[0] = itemKetua;
                if (itemWakilKetua) tempDataStruktural[1] = itemWakilKetua;
                if (itemSekretaris) tempDataStruktural[2] = itemSekretaris;
                if (itemSekretariat) tempDataStruktural[3] = itemSekretariat;
            } else if (formDatas.value.tipe_kolok == 'ukpd') {
                tempDataStruktural = [
                    { kolok: formDatas.value.kolok, kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'ketua', nrk: null, nama: null, nip: null, is_plt: 'tidak' },
                    { kolok: formDatas.value.kolok, kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'sekretaris', nrk: null, nama: null, nip: null, is_plt: 'tidak' },
                    { kolok: formDatas.value.kolok, kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'sekretariat', nrk: null, nama: null, nip: null, is_plt: 'tidak' },
                ];
                const itemKetua = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'ketua') : null;
                const itemSekretaris = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'sekretaris') : null;
                const itemSekretariat = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'sekretariat') : null;
                if (itemKetua) tempDataStruktural[0] = itemKetua;
                if (itemSekretaris) tempDataStruktural[1] = itemSekretaris;
                if (itemSekretariat) tempDataStruktural[2] = itemSekretariat;
            } else if (formDatas.value.tipe_kolok == 'upb') {
                tempDataStruktural = [
                    { kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'ketua', nrk: null, nama: null, nip: null, is_plt: 'tidak' },
                    { kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'sekretaris', nrk: null, nama: null, nip: null, is_plt: 'tidak' },
                ];
                const itemKetua = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'ketua') : null;
                const itemSekretaris = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_sk_tim_kode === 'sekretaris') : null;
                if (itemKetua) tempDataStruktural[0] = itemKetua;
                if (itemSekretaris) tempDataStruktural[1] = itemSekretaris;
            }
            /* jika data anggota ga kosong */
            if (formDatas.value.data_anggota && formDatas.value.data_anggota.length > 0) tempDataAnggota = formDatas.value.data_anggota;
            formDatas.value.data_struktural = tempDataStruktural;
            formDatas.value.data_anggota = tempDataAnggota;
            formDatas.value.removed_data_struktural = []; // nanti untuk menampung data struktural yang dihapus
            formDatas.value.removed_data_anggota = [];
            formDatas.value.data_struktural = formDatas.value.data_struktural.map(item => ({ ...item, kolok: formDatas.value.kolok, on_edit: false }));
            formDatas.value.data_anggota = formDatas.value.data_anggota.map(item => ({ ...item, kolok: formDatas.value.kolok, on_edit: false, test: 123 }));

        }
        /* On Mounted */

        /* ------------- */
        const updateDataStruktural = (index, newItem, oldItem, event) => {
            if (event == 'update') {
                // Check NRK sudah ada di struktural
                // let check = formDatas.value.data_struktural.find((element) => {
                //     return element.nrk == newItem.nrk
                // });
                // if (check) {
                //     showNotifikasi(g, 'warning', 'Warning', `NRK ${check.nrk} telah diinput sebagai ${check.ref_jabatan_sk_tim_kode}`)
                //     return;
                // }
                //
                if (formDatas.value.data_struktural[index].id) {
                    if (oldItem && (oldItem.nama && oldItem.nama != null) && (oldItem.nrk != newItem.nrk)) {
                        formDatas.value.removed_data_struktural.push(oldItem)
                    }
                }
                formDatas.value.data_struktural.splice(index, 1, newItem);
            } else {
                formDatas.value.data_struktural[index].on_edit = false;
            }

        };

        const updateDataAnggota = (index, newItem, oldItem, event) => {
            if (event == 'update') {
                if (formDatas.value.data_anggota[index].id) {
                    if (oldItem && (oldItem.nama && oldItem.nama != null) && oldItem.nrk != formDatas.value.data_anggota[index].nrk && oldItem.nama != formDatas.value.data_anggota[index].nama) {
                        formDatas.value.removed_data_anggota.push(oldItem);
                    } else if ((oldItem.nrk == '' || oldItem.nrk == null) || (oldItem.nrk != null && formDatas.value.data_anggota[index].nrk != null)) {
                        formDatas.value.removed_data_anggota.push(oldItem);
                    }
                }
                if (newItem.nama == null && newItem.nrk == null && newItem.nip == null) {
                    formDatas.value.data_anggota.splice(index, 1);
                } else {
                    formDatas.value.data_anggota.splice(index, 1, newItem);
                }
            } else {
                formDatas.value.data_anggota[index].on_edit = false;
                if (newItem.nama == null && newItem.nrk == null && newItem.nip == null) {
                    formDatas.value.data_anggota.splice(index, 1);
                }
            }

        };

        /* ------------------------------- */
        const addNewAnggota = () => {
            let newA = { kolok: formDatas.value.kolok, ref_jabatan_sk_tim_kode: 'anggota', nrk: null, nama: null, nip: null, on_edit: true, is_plt: 'tidak' };
            formDatas.value.data_anggota.push(newA);
        };

        const delPersonelDt = ref({
            index: null,
            pType: ''
        });
        const deleteModalRef = ref(null);
        const openDeleteModal = (index, pType) => {
            delPersonelDt.value.index = index;
            delPersonelDt.value.pType = pType;
            deleteModalRef.value.show();
        }

        const confirmDeletePersonil = () => {
            let i;
            if (delPersonelDt.value.pType == 'struktural') {
                i = formDatas.value.data_struktural[delPersonelDt.value.index]
                if (formDatas.value.data_struktural[delPersonelDt.value.index].id) {
                    formDatas.value.removed_data_struktural.push(i)
                }
                let nstr = { ...i };
                nstr.id = null
                nstr.nama = null
                nstr.nip = null
                nstr.nrk = null;
                formDatas.value.data_struktural.splice(delPersonelDt.value.index, 1, nstr);
            } else if (delPersonelDt.value.pType == 'anggota') {
                i = formDatas.value.data_anggota[delPersonelDt.value.index]
                if (formDatas.value.data_anggota[delPersonelDt.value.index].id) {
                    formDatas.value.removed_data_anggota.push(i)
                }
                formDatas.value.data_anggota.splice(delPersonelDt.value.index, 1);
            }

            deleteModalRef.value.hide();
            /* Langsung delete dari database */
            // skTim.saveAsDraft(g, formDatas.value).then(resp => {
            //     if (resp.success) {
            //         showNotifikasi(g, 'success', 'Success', resp.message)
            //     } else {
            //         showNotifikasi(g, 'danger', 'Error', resp.message)
            //     }
            // })
        };

        const loadingBtnSaveAsDraft = ref(false);
        const saveAsDraft = () => {
            loadingBtnSaveAsDraft.value = true;
            let payload = formDatas.value;
            payload.data_struktural = payload.data_struktural.filter(member => {
                return member.nrk !== null || member.nama !== null || member.nip !== null;
            });
            payload.data_anggota = payload.data_anggota.filter(member => {
                return member.nrk !== null || member.nama !== null || member.nip !== null;
            });
            skTim.saveAsDraft(g, payload).then(resp => {
                if (resp.success) {
                    showNotifikasi(g, 'success', 'Success', resp.message)
                    context.emit('changeStateEvent', 'detail');
                } else {
                    showNotifikasi(g, 'danger', 'Error', resp.message)
                }
                loadingBtnSaveAsDraft.value = false;
            }).catch(err => {
                console.log(err)
                loadingBtnSaveAsDraft.value = false;
            });
        };

        /* Submit SK Tim */
        const pengajuanValidasiModalRef = ref(null);
        const openPengajuanValidasiDialog = () => {
            pengajuanValidasiModalRef.value.show();
        };
        const loadingBtnPengajuan = ref(false);
        const confirmKirimPengajuanValidasi = () => {
            loadingBtnPengajuan.value = true;
            let payload = formDatas.value;

            /* Validasi Data Struktural Harus ada NRK */
            const dataStrukturalTanpaNRK = payload.data_struktural.filter(anggota => !anggota.nrk);
            if (dataStrukturalTanpaNRK.length) {
                let msg = `SK TIM untuk jabatan struktural harus diisi.`;
                dataStrukturalTanpaNRK.forEach(anggota => {
                    msg += `\n Jabatan: ${anggota.ref_jabatan_sk_tim_kode}, `;
                });
                showNotifikasi(g, 'warning', 'Warning', msg)
                loadingBtnPengajuan.value = false;
                return;
            }
            /* ---- */

            payload.data_struktural = payload.data_struktural.filter(member => {
                return member.nrk !== null || member.nama !== null || member.nip !== null;
            });
            payload.data_anggota = payload.data_anggota.filter(member => {
                return member.nrk !== null || member.nama !== null || member.nip !== null;
            });
            skTim.savePengajuan(g, payload).then(resp => {
                if (resp.success) {
                    showNotifikasi(g, 'success', 'Success', resp.message)
                    context.emit('changeStateEvent', 'detail');
                } else {
                    showNotifikasi(g, 'danger', 'Error', resp.message)
                }
                loadingBtnPengajuan.value = false;
            }).catch(err => {
                console.log(err)
                loadingBtnPengajuan.value = false;
            });
        };
        return {
            formDatas,
            addNewAnggota,
            openDeleteModal,
            updateDataStruktural,
            updateDataAnggota,
            deleteModalRef,
            confirmDeletePersonil,

            pengajuanValidasiModalRef,
            openPengajuanValidasiDialog,
            confirmKirimPengajuanValidasi,
            loadingBtnPengajuan,

            saveAsDraft,
            loadingBtnSaveAsDraft,

        };
    },
    computed: {
        headerSkTim() {
            if (this.formDatas.tipe_kolok == 'skpd') {
                return "Pengguna Barang";
            } else if (this.formDatas.tipe_kolok == 'ukpd') {
                return "Kuasa Pengguna Barang";
            } else if (this.formDatas.tipe_kolok == 'upb') {
                return "Sekolah";
            } else {
                return this.formDatas.tipe_kolok;
            }
        },
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect,
        BButton,
        BModal,
        FormLookupPegawai
    },
    methods: {
        changeStateEvent(event) {
            this.$emit('changeStateEvent', event);
        },
        lebelField(field) {
            if (field == 'ketua') {
                if (this.formDatas.tipe_kolok == 'skpd') {
                    return "Kepala PD";
                } else if (this.formDatas.tipe_kolok == 'ukpd') {
                    return "Kepala UKPD";
                } else if (this.formDatas.tipe_kolok == 'upb') {
                    return "Kepala UPB";
                }
            } else if (field == 'sekretaris') {
                if (this.formDatas.tipe_kolok == 'skpd') {
                    return "Pejabat Eselon IV";
                } else if (this.formDatas.tipe_kolok == 'ukpd') {
                    return "Pejabat Eselon IV";
                } else if (this.formDatas.tipe_kolok == 'upb') {
                    return "Kepala Tata Usaha";
                }
            } else if (field == 'sekretariat') {
                if (this.formDatas.tipe_kolok == 'skpd') {
                    return "Pengurus Barang";
                } else if (this.formDatas.tipe_kolok == 'ukpd') {
                    return "Pengurus Barang Pembantu";
                }
            } else if (field == 'anggota') {
                if (this.formDatas.tipe_kolok == 'skpd') {
                    return "Unsur Pada Bidang PD";
                } else if (this.formDatas.tipe_kolok == 'ukpd') {
                    return "Unsur Pada Bidang UKPD";
                } else if (this.formDatas.tipe_kolok == 'upb') {
                    return "Pengurus Barang/Unsur Pelaksana UPB";
                }
            }
        }
    },
    directives: {
        'b-modal': VBModal,
        Ripple,
    },
    data() {
        return {
            required,
        }
    },
}
</script>